<template>
	<main>
		<HeaderTab 
			:title="getTrad('monte.contract_new')"
			:icon="['fal', 'mars']"
		/>
		<div id="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12">
						<LoadingSpinner v-if="loading" />
						<div v-else-if="creation_closed" class="alert alert-warning mt-3">
							<font-awesome-icon :icon="['fal', 'exclamation-triangle']" class="mr-2" />
							{{ closed_message }}
						</div>
						<ContractForm v-else-if="show_form" :stallion_id="stallion_id" :mare_id="mare_id"/>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script type="text/javascript">
	import ContractMixin from "@/mixins/Contract.js"

	export default {
		name: "ContractNew",
		mixins: [ContractMixin],
		data () {
			return {
				loading: true,
				show_form: false,
				creation_closed: false,
				closed_message: '',
				stallion_id: null,
				mare_id: null
			}
		},
		mounted() {
			this.init_component()
		},
		methods: {
			/**
			 * Initialise le composant : résout les IDs étalon/jument depuis les params de
			 * la route, vérifie si la période de création de contrats est ouverte
			 * via la politique de confidentialité, puis affiche le formulaire ou un message
			 * de fermeture.
			 * @returns {Promise<void>}
			 */
			async init_component() {
				if(this.$route.params.stallion_id) {
					this.stallion_id = parseInt(this.$route.params.stallion_id)
				}
				if(this.$route.params.mare_id) {
					this.mare_id = parseInt(this.$route.params.mare_id)
				}
				const privacy = await this.contractPrivacyPolicy()
				const { closed, message } = this.isContractCreationClosed(privacy)
				if (closed) {
					this.closed_message = message || this.getTrad('monte.contract_creation_closed')
					this.creation_closed = true
					this.loading = false
					return
				}
				this.show_form = true
				this.loading = false
			},
		},
		components: {
			ContractForm : () => import('@/components/Contract/ContractForm'),
			HeaderTab: () => import('@/components/HeaderTab'),
			LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		},
	}
</script>
